export enum OneTimePaymentProvider {
  CreditCard = "CreditCard",
  PayPal = "PayPal",
  Zelle = "Zelle",
  Venmo = "Venmo",
  CashApp = "CashApp"
}

export enum OneTimePaymentMethodInputType {
  Url = "Url",
  Email = "Email",
  Phone = "Phone"
}
